// Bar levels for the Winamp skin's analyser.
//
// These are generated, not measured. Reading the tab's real AnalyserNode would
// cost one message per animation frame for as long as the popup is open, and
// at 19 bars by 16 levels the movement is indistinguishable — so the display
// is driven by playback state alone and the popup sends nothing.
export const SPECTRUM_BARS = 19;
export const SPECTRUM_LEVELS = 16;

// Music loses energy towards the top, so the right-hand bars sit lower —
// the shape that makes an analyser read as an analyser.
function barCeiling(bar) {
  const position = bar / (SPECTRUM_BARS - 1);
  return SPECTRUM_LEVELS * (1 - position * 0.55);
}

// Three detuned sines per bar: no repeating pattern the eye can lock onto,
// and no random() — the same time always yields the same frame, which keeps
// it testable.
function wobble(bar, time) {
  const a = Math.sin(time * 6.1 + bar * 1.7);
  const b = Math.sin(time * 2.3 + bar * 0.9 + 1.1);
  const c = Math.sin(time * 11.7 + bar * 2.6 + 2.3);
  return (a * 0.5 + b * 0.35 + c * 0.15 + 1) / 2;
}

/**
 * One frame of bar levels, each 0..SPECTRUM_LEVELS.
 *
 * `slowControl` ties the movement to the audio: a track slowed to 0.6 moves
 * the bars at roughly 0.6 speed. Paused playback rests at zero, and reduced
 * motion holds a static profile rather than animating.
 */
export function winampBarLevels({
  time = 0,
  playing = false,
  slowControl = 1,
  reducedMotion = false,
} = {}) {
  const bars = [];

  for (let bar = 0; bar < SPECTRUM_BARS; bar += 1) {
    if (!playing) {
      bars.push(0);
      continue;
    }
    const ceiling = barCeiling(bar);
    if (reducedMotion) {
      bars.push(Math.round(ceiling * 0.4));
      continue;
    }
    const rate = Math.max(0.25, Math.min(2, Number(slowControl) || 1));
    const level = ceiling * (0.25 + wobble(bar, time * rate) * 0.75);
    bars.push(Math.max(0, Math.min(SPECTRUM_LEVELS, Math.round(level))));
  }

  return bars;
}
